const prodConfig = {
  MASTER_TOKEN: 'IrBS0xWt5rXItycGGO9X7iYyV5sM8zKo',
  IMAGE_URL: './assets/images/',
  API_URL: 'https://api.dltwired.com/api',
  USER_TYPE_POSITION: 6
}

module.exports = prodConfig
